import React from 'react';

import RichText from '@elements/RichText';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

import './style.css';

type CardBodyType = {
  childClassName: string,
  content: {
    raw: string
  },
  image?: IGatsbyImageData,
  imageTitle?: string,
  useFilter?: boolean,
};
let filterClass = null

const CardBody = ({ 
  childClassName,
  content,
  image,
  imageTitle,
  useFilter,
}: CardBodyType): JSX.Element => (
  <div className={childClassName}>
    {useFilter ? filterClass = 'generic__card--use-filter' : filterClass = ''}
    {
      image && (
        <figure className={filterClass}>
          <GatsbyImage alt={imageTitle} image={image}/>
        </figure>
      )
    }
    <div className="card--body">
      <div className="card__body-inner">
        {
          content && <RichText bodyRichText={content} />
        }
      </div>
    </div>
  </div>
);

export default CardBody;
